import React from 'react';

export const Preloader = () => (
    <div style={{width: '100%', height: '100px', borderRadius: '7px', background: '#f3f3f3', marginTop: '10px'}} />
);
